import { render, staticRenderFns } from "./ProfileDialog.vue?vue&type=template&id=f7a76c82&scoped=true&"
import script from "./ProfileDialog.vue?vue&type=script&lang=js&"
export * from "./ProfileDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDialog.vue?vue&type=style&index=0&id=f7a76c82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a76c82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
